<template>
  <b-modal title="Detalhes do Certificado" v-model="show" size="xl">
    <b-container fluid>
      <b-row class="mt-2">
        <b-col cols="6">
          <b-form-group label="Local:" label-for="local" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="local" v-model="template.local" />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Nº Pedido:" label-for="pedido" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="pedido" v-model="template.pedido" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-form-group label="Nº OS:" label-for="os" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="os" v-model="template.ordem" />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Doc. Técnico:" label-for="doc" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="doc" v-model="template.documento" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-form-group label="Procedimento:" label-for="procedimento" label-cols-sm="3" label-align-sm="right">
            <b-form-select v-model="template.procedimento">
              <b-form-select-option v-for="documento of getDocumentos" v-bind:key="documento.id" :value="documento.numero"
                >{{ documento.descricao }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Imagens:" label-cols-sm="3" label-align-sm="right">
            <b-form-file
              type="file"
              class="text-left"
              v-model="arquivo"
              placeholder="Solte as fotos da imagem .jpg"
              accept=".jpg"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-form-group label="Resultado:" label-for="resultado" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="resultado" v-model="template.resultado" />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Validade:" label-for="validade" label-cols-sm="3" label-align-sm="right">
            <b-form-input id="validade" v-model="template.validade" type="number" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-alert show variant="dark" class="text-center">Etapas da Certificação</b-alert>
      <b-row>
        <b-col cols="12">
          <b-list-group>
            <b-list-group-item
              v-for="item in template.itens"
              :key="item.id"
              class="d-flex justify-content-between align-items-center"
            >
              {{ item.message }}
              <b-badge :variant="item.variant" class="text-right">{{ item.result }}</b-badge>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col cols="6" class="p-1 m-0">
          <b-form-group label="Info:" label-for="info" label-cols-sm="2" label-align-sm="right">
            <b-form-input id="info" v-model="item.message" />
          </b-form-group>
        </b-col>
        <b-col cols="2" class="p-1 m-0">
          <b-form-select v-model="item.variant" :options="variants"></b-form-select>
        </b-col>
        <b-col cols="2" class="p-1 m-0">
          <b-form-select v-model="item.result" :options="results"></b-form-select>
        </b-col>
        <b-col cols="1" class="p-1 pl-3 m-0">
          <b-button variant="primary" @click="adicionar()">
            <b-icon icon="plus-circle" variant="light" scale="1.1" class="mr-2 ml-2" />
          </b-button>
        </b-col>
        <b-col cols="1" class="p-1 m-0">
          <b-button variant="warning" @click="remover()">
            <b-icon icon="dash-circle" variant="light" scale="1.1" class="mr-2 ml-2" />
          </b-button>
        </b-col>
      </b-row>

      <hr />
      <b-row>
        <b-col cols="6">
          <b-form-group label="Inspetor:" label-for="inspetor" label-cols-sm="3" label-align-sm="right">
            <b-form-select v-model="template.inspetor">
              <b-form-select-option v-for="profissional of getProfissionais" v-bind:key="profissional.id" :value="profissional"
                >{{ profissional.nome }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Responsável:" label-for="resp" label-cols-sm="3" label-align-sm="right">
            <b-form-select v-model="template.responsavel">
              <b-form-select-option v-for="profissional of getProfissionais" v-bind:key="profissional.id" :value="profissional"
                >{{ profissional.nome }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-form-group label-cols-sm="2" label="Observação:" label-align-sm="center">
            <b-form-textarea v-model="template.observacao" rows="4"></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>

    <!-- :::::::::::::::::::::::::::: MODAL DE EDIÇÃO :::::::::::::::::::::::::::: -->
    <template-modal ref="templateCertificado" @loadTemplate="loadTemplate($event)" />

    <template #modal-footer>
      <b-button variant="info" @click="templates()">Templates</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { useClienteStore } from "@/stores/ClienteStore";
import { useDocumentoStore } from "@/stores/DocumentoStore";
import { useProfissionalStore } from "@/stores/ProfissionalStore";
import { storeToRefs } from "pinia";
import Files from "@/http/files";
import Certificado from "@/models_reports/Certificado";
import CertificadoItem from "@/models_reports/CertificadoItem";
import CertificadoTemplateModal from "@/components/modals/template/CertificadoTemplateModal";

export default {
  name: "ModalDeTemplateCertificado",

  components: {
    "template-modal": CertificadoTemplateModal,
  },

  data() {
    return {
      show: false,
      files: new Files(this.$http),
      template: new Certificado(),
      arquivo: null,
      item: { message: "", variant: "", result: "" },
      variants: [
        { value: "success", text: "Verde" },
        { value: "info", text: "Azul" },
        { value: "warning", text: "Amarelo" },
        { value: "danger", text: "Vermelho" },
      ],
      results: [
        { value: "APROVADO", text: "APROVADO" },
        { value: "INFORMATIVO", text: "INFORMATIVO" },
        { value: "PENDENTE", text: "PENDENTE" },
        { value: "REPROVADO", text: "REPROVADO" },
      ],
    };
  },

  watch: {
    arquivo: function (newValue) {
      this.$emit("loadCertificado", newValue);
    },
  },

  methods: {
    adicionar() {
      let item = new CertificadoItem();
      item.message = this.item.message;
      item.variant = this.item.variant;
      item.result = this.item.result;
      this.template.itens.push(item);
    },

    remover() {
      if (this.template.itens.length > 0) {
        this.template.itens.pop();
      }
    },

    templates() {
      this.$refs.templateCertificado.call();
    },

    loadTemplate(template) {
      this.template.update(template);
    },

    call(certificado) {
      this.show = !this.show;
      this.template = certificado;
    },
  },

  setup() {
    const store = useSgcqStore();
    const clienteStore = useClienteStore();
    const documentoStore = useDocumentoStore();
    const { getDocumentos } = storeToRefs(documentoStore);
    const profissionalStore = useProfissionalStore();
    const { getProfissionais } = storeToRefs(profissionalStore);

    return {
      store,
      clienteStore,
      documentoStore,
      getDocumentos,
      profissionalStore,
      getProfissionais,
    };
  },
};
</script>

<style lang="scss" scoped></style>
